export const MIROSLAVA_BOUNDARY = {
  type: "Feature",
  properties: {
    name: "Miroslava",
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [27.427779, 47.1654936],
        [27.4296973, 47.1647926],
        [27.4305915, 47.1642694],
        [27.4321992, 47.163609],
        [27.4330748, 47.1630815],
        [27.4332013, 47.1628098],
        [27.433463, 47.1626136],
        [27.4350312, 47.1620394],
        [27.4360893, 47.1617038],
        [27.4364858, 47.1615098],
        [27.4368664, 47.1611712],
        [27.4370571, 47.1611044],
        [27.4373265, 47.1610771],
        [27.4379917, 47.1611479],
        [27.4386088, 47.1613119],
        [27.4394437, 47.1616528],
        [27.4395193, 47.1615868],
        [27.4396102, 47.1613375],
        [27.4395074, 47.1611615],
        [27.4395654, 47.1607754],
        [27.4394075, 47.160634],
        [27.4393201, 47.1604513],
        [27.4394364, 47.1602338],
        [27.439459, 47.1600394],
        [27.4396332, 47.1598996],
        [27.4396798, 47.1597142],
        [27.4398837, 47.1595532],
        [27.4399374, 47.1593014],
        [27.4401622, 47.1590052],
        [27.4402117, 47.1587638],
        [27.4405149, 47.1585775],
        [27.4404843, 47.1583622],
        [27.44112, 47.1578056],
        [27.4412195, 47.1575484],
        [27.4412883, 47.1569546],
        [27.4414353, 47.156586],
        [27.4415558, 47.1565564],
        [27.4416634, 47.1564526],
        [27.4422389, 47.1551329],
        [27.4431418, 47.153642],
        [27.4433433, 47.1533745],
        [27.4435481, 47.1532948],
        [27.4436558, 47.1527518],
        [27.4435596, 47.1525862],
        [27.4437507, 47.1513766],
        [27.4441701, 47.1512698],
        [27.4442292, 47.1510415],
        [27.4444235, 47.1508119],
        [27.4441183, 47.150622],
        [27.4439517, 47.1502442],
        [27.443954, 47.1500622],
        [27.4442314, 47.1498776],
        [27.4442263, 47.1496459],
        [27.4440562, 47.1496137],
        [27.4438991, 47.1497],
        [27.4437914, 47.149726],
        [27.4437483, 47.1496978],
        [27.4439354, 47.1493483],
        [27.4438461, 47.1491655],
        [27.4436626, 47.1490112],
        [27.443847, 47.1488905],
        [27.4439723, 47.1486846],
        [27.4437998, 47.1483226],
        [27.4437018, 47.1482509],
        [27.4437248, 47.1480437],
        [27.4440368, 47.1476072],
        [27.4441925, 47.147717],
        [27.4442972, 47.1476905],
        [27.4440119, 47.147275],
        [27.4441455, 47.1461197],
        [27.4444863, 47.1452251],
        [27.4446473, 47.1444719],
        [27.4445166, 47.1442852],
        [27.4446887, 47.1439388],
        [27.4448324, 47.1436613],
        [27.4460353, 47.1405178],
        [27.4473546, 47.1377432],
        [27.4481968, 47.1357456],
        [27.4485297, 47.1351268],
        [27.4486326, 47.1346478],
        [27.4489296, 47.1340512],
        [27.4489859, 47.1338088],
        [27.4503781, 47.1307944],
        [27.4514225, 47.128021],
        [27.4519945, 47.1271621],
        [27.4525629, 47.1252436],
        [27.4509402, 47.1252765],
        [27.4531018, 47.1200829],
        [27.4546899, 47.1201822],
        [27.4551118, 47.1190023],
        [27.4563688, 47.1161859],
        [27.4567152, 47.1151674],
        [27.4575642, 47.1132631],
        [27.4509458, 47.1127523],
        [27.4517307, 47.1114565],
        [27.4520654, 47.1105367],
        [27.4529303, 47.109255],
        [27.4533851, 47.1084763],
        [27.4541184, 47.1069525],
        [27.4553512, 47.1034217],
        [27.4554692, 47.103083],
        [27.4555553, 47.1029053],
        [27.4556391, 47.102675],
        [27.4574594, 47.1026397],
        [27.4619375, 47.1005564],
        [27.4638817, 47.0997225],
        [27.4693397, 47.097084],
        [27.474026, 47.096121],
        [27.4744484, 47.0957765],
        [27.4823478, 47.0919442],
        [27.4828993, 47.0917045],
        [27.4831486, 47.0916837],
        [27.4833667, 47.0917235],
        [27.483425, 47.0915746],
        [27.483614, 47.0914297],
        [27.4840073, 47.0909307],
        [27.4854711, 47.0898853],
        [27.4856758, 47.0898021],
        [27.4861224, 47.0890733],
        [27.4866883, 47.0885216],
        [27.4871052, 47.0882293],
        [27.4875531, 47.0881184],
        [27.4879867, 47.0879332],
        [27.4885619, 47.0876485],
        [27.4887969, 47.0874629],
        [27.4888635, 47.0873088],
        [27.488838, 47.0868454],
        [27.4888964, 47.0866829],
        [27.4891473, 47.0863821],
        [27.4897525, 47.0858378],
        [27.4900727, 47.0856134],
        [27.4918703, 47.0849099],
        [27.4936327, 47.0838763],
        [27.4955147, 47.0824684],
        [27.4955321, 47.082458],
        [27.4961036, 47.0821034],
        [27.4967799, 47.0815101],
        [27.4973144, 47.0812701],
        [27.4977733, 47.0809669],
        [27.4979473, 47.0807289],
        [27.4981796, 47.080531],
        [27.4986207, 47.0798977],
        [27.4989729, 47.0796678],
        [27.5002742, 47.0790583],
        [27.5005791, 47.0788736],
        [27.5012892, 47.0786208],
        [27.5029592, 47.0789095],
        [27.5031312, 47.0789031],
        [27.5037177, 47.07868],
        [27.5049742, 47.0778912],
        [27.5055546, 47.0777738],
        [27.5059712, 47.0776348],
        [27.5060672, 47.0774924],
        [27.5063126, 47.0773046],
        [27.5066473, 47.076857],
        [27.5069539, 47.0765924],
        [27.5077443, 47.0761086],
        [27.5081706, 47.0759059],
        [27.5088805, 47.0753317],
        [27.510664, 47.0741105],
        [27.510691, 47.0740175],
        [27.5105779, 47.0737393],
        [27.5095998, 47.0718936],
        [27.5092012, 47.0714356],
        [27.5093293, 47.0709444],
        [27.5093171, 47.0706971],
        [27.5094336, 47.0704758],
        [27.5095234, 47.0704326],
        [27.5104037, 47.0702827],
        [27.5116665, 47.0698988],
        [27.5126906, 47.0694228],
        [27.512944, 47.0695069],
        [27.5140475, 47.0696359],
        [27.5155512, 47.0697008],
        [27.516506, 47.0698328],
        [27.5187204, 47.0697594],
        [27.5202112, 47.069897],
        [27.5208285, 47.0699095],
        [27.5217418, 47.070022],
        [27.5220165, 47.0699497],
        [27.5220827, 47.0700693],
        [27.5229921, 47.0700402],
        [27.5234509, 47.07014],
        [27.523613, 47.0700885],
        [27.524159, 47.0700742],
        [27.5253355, 47.0700918],
        [27.5259275, 47.0701904],
        [27.526216, 47.0703315],
        [27.5266346, 47.0709535],
        [27.5268864, 47.0717511],
        [27.5270942, 47.071995],
        [27.5276102, 47.0724599],
        [27.5274799, 47.0727051],
        [27.5274174, 47.0730418],
        [27.527632, 47.0735302],
        [27.5268483, 47.0747726],
        [27.5268235, 47.0751608],
        [27.5265134, 47.0759528],
        [27.5259965, 47.0762128],
        [27.5261287, 47.0767607],
        [27.5263037, 47.0771357],
        [27.5275025, 47.0781368],
        [27.528794, 47.0787114],
        [27.5359444, 47.0807726],
        [27.5373375, 47.0810685],
        [27.5379124, 47.0813694],
        [27.5397797, 47.0819255],
        [27.5446358, 47.0832073],
        [27.5447342, 47.0838966],
        [27.5474227, 47.0843197],
        [27.5488131, 47.0834374],
        [27.5492703, 47.0828398],
        [27.5495259, 47.0826741],
        [27.5503531, 47.0822584],
        [27.5516694, 47.0816865],
        [27.5530066, 47.0847389],
        [27.5527305, 47.0848605],
        [27.5525952, 47.0849744],
        [27.5521524, 47.0851075],
        [27.5518197, 47.0851046],
        [27.5512552, 47.0849141],
        [27.5515027, 47.0855067],
        [27.5523634, 47.0860088],
        [27.5519906, 47.0861682],
        [27.54995, 47.0881786],
        [27.5484233, 47.0895482],
        [27.5484242, 47.0896579],
        [27.5497515, 47.090039],
        [27.549733, 47.0900727],
        [27.5498905, 47.0901381],
        [27.5494555, 47.0907639],
        [27.5496468, 47.0910578],
        [27.5503702, 47.0911538],
        [27.5504814, 47.0913039],
        [27.5492887, 47.0928639],
        [27.5485282, 47.0926128],
        [27.5481574, 47.0932077],
        [27.5479239, 47.093203],
        [27.5472305, 47.093038],
        [27.5466163, 47.0929502],
        [27.5456229, 47.0928908],
        [27.5452899, 47.0928184],
        [27.5421846, 47.0958619],
        [27.5450511, 47.0961333],
        [27.5445764, 47.1000204],
        [27.5444403, 47.1003802],
        [27.5445015, 47.1004524],
        [27.5441008, 47.100918],
        [27.5447551, 47.1011251],
        [27.546156, 47.1013223],
        [27.5485586, 47.1018495],
        [27.5486233, 47.1017723],
        [27.5488841, 47.101813],
        [27.5488786, 47.1019143],
        [27.5508994, 47.1021852],
        [27.5508989, 47.102239],
        [27.5511826, 47.1022241],
        [27.551517, 47.1023222],
        [27.5515353, 47.1036999],
        [27.5542892, 47.1038398],
        [27.5559352, 47.1040034],
        [27.5561732, 47.1040326],
        [27.5562589, 47.1040833],
        [27.5562579, 47.1041607],
        [27.5561698, 47.1045214],
        [27.5563008, 47.1062649],
        [27.5566213, 47.1062602],
        [27.5566118, 47.1065988],
        [27.5565493, 47.1066535],
        [27.5565711, 47.1070343],
        [27.5566408, 47.1070367],
        [27.5566337, 47.1072921],
        [27.5565718, 47.1073068],
        [27.5565746, 47.1073954],
        [27.5565028, 47.107393],
        [27.556528, 47.1079514],
        [27.5594255, 47.1079944],
        [27.5595971, 47.1079439],
        [27.5591172, 47.1096862],
        [27.5591278, 47.1100252],
        [27.5605415, 47.1119718],
        [27.5606016, 47.1131059],
        [27.5608808, 47.1137446],
        [27.5628914, 47.1166939],
        [27.5638311, 47.1184795],
        [27.5644239, 47.1192822],
        [27.5653155, 47.1206685],
        [27.5644735, 47.1209797],
        [27.5642633, 47.1212292],
        [27.563002, 47.1218556],
        [27.5624383, 47.1220325],
        [27.5619078, 47.1223979],
        [27.5601061, 47.1234711],
        [27.5599176, 47.1236865],
        [27.560101, 47.1238946],
        [27.5601941, 47.1238508],
        [27.5608976, 47.1245309],
        [27.5630722, 47.125674],
        [27.5632254, 47.1255338],
        [27.5647273, 47.1262595],
        [27.5651254, 47.1263464],
        [27.5653139, 47.1268726],
        [27.5618808, 47.129486],
        [27.560101, 47.1307514],
        [27.5609046, 47.1315986],
        [27.5638224, 47.1344153],
        [27.551874, 47.1401292],
        [27.5486715, 47.1418844],
        [27.5533523, 47.1460362],
        [27.5533024, 47.1460714],
        [27.5535587, 47.1463167],
        [27.5535138, 47.146445],
        [27.5455533, 47.1451448],
        [27.545245, 47.145121],
        [27.5449195, 47.1451183],
        [27.5397942, 47.1450735],
        [27.5392201, 47.145025],
        [27.5387926, 47.1449207],
        [27.5387068, 47.1450752],
        [27.5388037, 47.1466643],
        [27.5388701, 47.1468699],
        [27.5390651, 47.1470312],
        [27.538988, 47.1475596],
        [27.5387517, 47.1474909],
        [27.5378771, 47.1475769],
        [27.5374544, 47.1481479],
        [27.5368821, 47.1497224],
        [27.5369696, 47.1501575],
        [27.5368061, 47.1510469],
        [27.5366957, 47.1510733],
        [27.5366697, 47.1511513],
        [27.5367066, 47.1512645],
        [27.5364678, 47.1513194],
        [27.5361992, 47.1514875],
        [27.5358664, 47.1514864],
        [27.535777, 47.1517663],
        [27.535735, 47.1527031],
        [27.5359177, 47.1527043],
        [27.5359972, 47.1529453],
        [27.5361419, 47.1531119],
        [27.5363539, 47.1532176],
        [27.5363461, 47.1534911],
        [27.5366206, 47.1540321],
        [27.5367179, 47.1559753],
        [27.5366223, 47.1570395],
        [27.5363305, 47.1580919],
        [27.5359655, 47.1587333],
        [27.5357713, 47.1592057],
        [27.5355464, 47.1595281],
        [27.535364, 47.1600513],
        [27.5337594, 47.1602069],
        [27.5336287, 47.1602196],
        [27.5327909, 47.160206],
        [27.5314787, 47.1598563],
        [27.5306331, 47.1595823],
        [27.5303751, 47.1601512],
        [27.5280311, 47.159395],
        [27.527504, 47.1593041],
        [27.5261691, 47.1588864],
        [27.5251531, 47.1586848],
        [27.5214313, 47.1581342],
        [27.5197886, 47.1577777],
        [27.5188846, 47.1577033],
        [27.5156904, 47.1581283],
        [27.514727, 47.1581471],
        [27.5131926, 47.1582885],
        [27.5099692, 47.1584624],
        [27.5069852, 47.1590174],
        [27.5059896, 47.1591438],
        [27.5005553, 47.1600258],
        [27.4994339, 47.16028],
        [27.4973807, 47.1603287],
        [27.4960426, 47.1600685],
        [27.4955669, 47.1601446],
        [27.4949236, 47.160032],
        [27.4928284, 47.1601262],
        [27.4924286, 47.1600598],
        [27.4922463, 47.1597731],
        [27.492179, 47.1601948],
        [27.4913973, 47.1608883],
        [27.4867679, 47.1631137],
        [27.4867604, 47.164193],
        [27.486626, 47.1668129],
        [27.4863967, 47.1677346],
        [27.4865659, 47.1687229],
        [27.4866764, 47.170223],
        [27.4867064, 47.1707766],
        [27.4867474, 47.1717784],
        [27.4867184, 47.1723767],
        [27.485308, 47.1723764],
        [27.4849149, 47.1723072],
        [27.4848866, 47.1722074],
        [27.4847237, 47.1722168],
        [27.4847092, 47.1723927],
        [27.4844135, 47.1724288],
        [27.4844542, 47.1726415],
        [27.4838348, 47.172735],
        [27.4828804, 47.1729148],
        [27.4820474, 47.1731047],
        [27.4812962, 47.1732941],
        [27.481425, 47.1736919],
        [27.4798765, 47.1743865],
        [27.4793317, 47.1747172],
        [27.4788999, 47.1750086],
        [27.4787252, 47.1752413],
        [27.478135, 47.1759919],
        [27.4776472, 47.1766485],
        [27.4774884, 47.1768678],
        [27.4773963, 47.1770627],
        [27.4772706, 47.1776843],
        [27.4765545, 47.1797973],
        [27.4766813, 47.1801131],
        [27.4884766, 47.1774687],
        [27.4883883, 47.1803722],
        [27.4882267, 47.1810693],
        [27.4879878, 47.1817295],
        [27.4868926, 47.182536],
        [27.4825671, 47.185883],
        [27.4809209, 47.1870484],
        [27.4800864, 47.1875741],
        [27.4794909, 47.1878777],
        [27.4793344, 47.1883956],
        [27.4790307, 47.1883249],
        [27.4787493, 47.1886331],
        [27.4786099, 47.1888754],
        [27.4782595, 47.1894843],
        [27.4745215, 47.2001204],
        [27.4720607, 47.2067784],
        [27.471118, 47.2096573],
        [27.4708391, 47.2102512],
        [27.4702887, 47.211027],
        [27.4680384, 47.2140503],
        [27.4676651, 47.2144264],
        [27.4670113, 47.215572],
        [27.4658681, 47.2210983],
        [27.4656657, 47.2224942],
        [27.4656376, 47.222581],
        [27.4643548, 47.2231276],
        [27.4613577, 47.2241331],
        [27.4605374, 47.2241779],
        [27.458915, 47.2247424],
        [27.4579295, 47.2250268],
        [27.4575261, 47.2251753],
        [27.4571859, 47.22566],
        [27.456304, 47.2257143],
        [27.4556356, 47.2262568],
        [27.455517, 47.2264529],
        [27.4555384, 47.2268676],
        [27.4552602, 47.2275344],
        [27.4551285, 47.2275648],
        [27.4546965, 47.2275394],
        [27.4524427, 47.228004],
        [27.4515094, 47.2281396],
        [27.4508736, 47.228153],
        [27.4487299, 47.2277685],
        [27.4486264, 47.22787],
        [27.4484272, 47.2279042],
        [27.4480022, 47.2280926],
        [27.4467922, 47.2289185],
        [27.4457343, 47.2294741],
        [27.4449716, 47.2297829],
        [27.4443507, 47.2298257],
        [27.4438671, 47.2297974],
        [27.4416735, 47.2296547],
        [27.4425996, 47.2252647],
        [27.4436939, 47.2210388],
        [27.4438629, 47.220035],
        [27.4438729, 47.2196437],
        [27.4440374, 47.2191974],
        [27.4438852, 47.2183047],
        [27.4446303, 47.216645],
        [27.4448628, 47.2159325],
        [27.4453047, 47.2149486],
        [27.4468677, 47.2120428],
        [27.4473613, 47.2108818],
        [27.4486502, 47.2083268],
        [27.4493413, 47.206624],
        [27.449572, 47.2053279],
        [27.4502229, 47.1998926],
        [27.4510393, 47.1940436],
        [27.451055, 47.1931727],
        [27.4514211, 47.1917163],
        [27.4514141, 47.1895286],
        [27.4515769, 47.1893316],
        [27.4518589, 47.1891862],
        [27.452713, 47.1885478],
        [27.4521012, 47.1879277],
        [27.4520772, 47.1873422],
        [27.4522589, 47.1869178],
        [27.4524202, 47.1867184],
        [27.452279, 47.1863735],
        [27.4525692, 47.185152],
        [27.4530252, 47.1850581],
        [27.4529546, 47.1837946],
        [27.453096, 47.1830369],
        [27.4521011, 47.1811318],
        [27.4517393, 47.1803081],
        [27.4391211, 47.1832986],
        [27.4376421, 47.18056],
        [27.4372262, 47.1804879],
        [27.4369909, 47.1802921],
        [27.4369731, 47.180051],
        [27.4371055, 47.1798195],
        [27.4371168, 47.1796533],
        [27.4370448, 47.1793324],
        [27.4369663, 47.1792384],
        [27.4364958, 47.1789839],
        [27.4359536, 47.1784572],
        [27.4350768, 47.1778632],
        [27.4351647, 47.1776359],
        [27.4353848, 47.1774979],
        [27.43738, 47.1767924],
        [27.438585, 47.1762431],
        [27.439825, 47.1758666],
        [27.4409648, 47.1753047],
        [27.4430628, 47.1744808],
        [27.4433777, 47.1744027],
        [27.4453635, 47.1735851],
        [27.4445755, 47.1718227],
        [27.4439334, 47.1711889],
        [27.4428913, 47.1704531],
        [27.442606, 47.1704939],
        [27.4423385, 47.1703542],
        [27.4416753, 47.1698017],
        [27.4411163, 47.1696272],
        [27.4406676, 47.1693572],
        [27.4404447, 47.1690733],
        [27.4400607, 47.1690896],
        [27.4400786, 47.1693239],
        [27.4398574, 47.1694303],
        [27.4392912, 47.1700566],
        [27.4390552, 47.1702154],
        [27.4383175, 47.1704748],
        [27.4366712, 47.1708667],
        [27.4365353, 47.1708696],
        [27.4361395, 47.1707476],
        [27.4354643, 47.1710277],
        [27.4337836, 47.1719892],
        [27.4334649, 47.1719912],
        [27.4331282, 47.171842],
        [27.4329626, 47.1722478],
        [27.4324303, 47.1725459],
        [27.4314028, 47.1730202],
        [27.4309317, 47.1734602],
        [27.4306186, 47.1736459],
        [27.4302475, 47.1736871],
        [27.4295184, 47.1738715],
        [27.4287098, 47.1738883],
        [27.4281822, 47.1698966],
        [27.4279695, 47.1667815],
        [27.4280471, 47.1665949],
        [27.427779, 47.1654936]
      ],
    ],
  },
} as const;

